var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.907,
    height: 23,
    viewBox: "0 0 22.907 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53270",
    "data-name": "Rectangle 53270",
    width: 22.907,
    height: 23,
    fill: "#80838e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_146945",
    "data-name": "Group 146945",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50307",
    "data-name": "Path 50307",
    d: "M20.953,11.446a1.23,1.23,0,0,0-1.227-1.232H5.818a1.23,1.23,0,0,0-1.227,1.232v2.464H20.953Zm-13.908.411H6.227v.821a.409.409,0,1,1-.818,0V11.446a.41.41,0,0,1,.409-.411H7.045a.411.411,0,0,1,0,.821Z",
    transform: "translate(-1.318 -1.179)",
    fill: "#80838e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50308",
    "data-name": "Path 50308",
    d: "M4.591,24.286a1.23,1.23,0,0,0,1.227,1.232H19.726a1.23,1.23,0,0,0,1.227-1.232V21.821H4.591Z",
    transform: "translate(-1.318 -2.518)",
    fill: "#80838e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50309",
    "data-name": "Path 50309",
    d: "M23.39,15.321H1.3a.41.41,0,0,0-.409.411v4.107a.41.41,0,0,0,.409.411H23.39a.41.41,0,0,0,.409-.411V15.732A.41.41,0,0,0,23.39,15.321ZM4.8,18.265a.41.41,0,0,1-.454.683l-.591-.4v.465a.409.409,0,1,1-.818,0v-.465l-.591.4a.41.41,0,0,1-.454-.683l.718-.48-.718-.48a.41.41,0,0,1,.454-.683l.591.4v-.465a.409.409,0,1,1,.818,0v.465l.591-.4a.41.41,0,0,1,.454.683l-.718.48Zm4.5,0a.41.41,0,0,1-.454.683l-.591-.4v.465a.409.409,0,1,1-.818,0v-.465l-.591.4a.41.41,0,0,1-.454-.683l.718-.48-.717-.48a.41.41,0,0,1,.454-.683l.59.4v-.465a.409.409,0,1,1,.818,0v.465l.591-.4a.41.41,0,0,1,.454.683l-.718.48Zm4.5,0a.41.41,0,0,1-.454.683l-.591-.4v.465a.409.409,0,1,1-.818,0v-.465l-.591.4a.41.41,0,0,1-.454-.683l.718-.48-.717-.48a.41.41,0,0,1,.454-.683l.59.4v-.465a.409.409,0,1,1,.818,0v.465l.591-.4a.41.41,0,0,1,.454.683l-.718.48Zm4.5,0a.41.41,0,0,1-.454.683l-.591-.4v.465a.409.409,0,1,1-.818,0v-.465l-.591.4a.41.41,0,0,1-.454-.683l.718-.48-.717-.48a.41.41,0,0,1,.454-.683l.59.4v-.465a.409.409,0,1,1,.818,0v.465l.591-.4a.41.41,0,0,1,.454.683l-.718.48Zm4.273,1.163H20.117a.411.411,0,0,1,0-.821h2.454a.411.411,0,0,1,0,.821Z",
    transform: "translate(-0.891 -1.768)",
    fill: "#80838e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50310",
    "data-name": "Path 50310",
    d: "M8.539,6.161a4.5,4.5,0,1,1,9,0V8.214h1.636V6.161a6.136,6.136,0,1,0-12.272,0V8.214H8.539Z",
    transform: "translate(-1.585)",
    fill: "#80838e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.fd07e6317ca2d0b676fe8b44f4f15749.svg";
export { ForwardRef as ReactComponent };